<template>
  <div class="container">
    <sys-filter :filters.sync="filters" :server="true" :items="items" :filtered_items.sync="filtered_items" @getItems="getItems" :options="positions"/>
    <div class="row pb-5">
      <sys-widget title="Cantidad de Colaboradores" :content="meta.total" icon="users" />
      <sys-widget title="Ahorro estimado" :content="meta.total_amount | formatCurrency" icon="dollar-sign" color="secondary"/>
    </div>
    <sys-server-table :headers="headers" :tableData="tableData" :pagination="pagination" :items="items" :title="title" :error_message="error_message" :detail_route="detail_route" :create_route="create_route" @getItems="getItems" />
  </div>
</template>

<script>
import colabsService from '@/services/colaborators'
import SysServerTable from '@/components/shared/ServerTable'
import SysFilter from '@/components/shared/Filter'
import SysWidget from '@/components/shared/Widget'
import formatCurrency from '@/filters/formatCurrency'
import reverseDate from '@/filters/reverseDate'

export default {
  name: 'Colaborators',

  components: { SysServerTable, SysFilter, SysWidget },
  created () {
    this.getItems()
    colabsService.getPositionsList().then(res => {
      this.positions = res.data.map(position => {
        return { value: position.name, text: position.name }
      })
    })
  },
  data () {
    return {
      title: 'Colaboradores',
      headers: [
        { text: 'Id', value: 'id' },
        { text: 'Nombre', value: 'fullname' },
        { text: 'Email', value: 'email' },
        { text: 'Sueldo', value: 'salary', filter: formatCurrency },
        { text: 'Monto de Ahorro', value: 'acumulated_amount', filter: formatCurrency },
        { text: 'Estatus', value: 'status' },
        { text: 'Puesto', value: 'position' },
        { text: 'Fecha de Inicio', value: 'start_date' },
        { text: 'Fecha de Nacimiento', value: 'dob' }
      ],
      items: [],
      positions: [],
      filtered_items: [],
      items_sum: 0,
      error_message: 'There\'s nothing to show :c',
      detail_route: 'colaborator',
      create_route: 'colaborator_create',
      tableData: {
        draw: 0,
        length: 10,
        search: '',
        column: 0,
        dir: 'desc'
      },
      meta: {
        total: 0,
        total_amount: 0
      },
      pagination: {
        lastPage: '',
        currentPage: '',
        total: '',
        links: {},
        from: 1,
        to: 10
      },
      filters: [
        {
          id: 'name',
          name: 'Nombre',
          hint: 'Colaborador',
          icon: 'user',
          type: 'text',
          value: '',
          size: 3,
          validator: (item, value) => item.name.toLowerCase().includes(value.toLowerCase())
        },
        {
          id: 'email',
          name: 'Correo',
          hint: 'Correo electrónico',
          icon: 'mail-bulk',
          type: 'text',
          value: '',
          size: 3,
          validator: (item, value) => item.email.toLowerCase().includes(value.toLowerCase())
        },
        {
          id: 'status',
          name: 'Estatus',
          hint: 'Estatus',
          icon: 'user',
          type: 'text',
          value: '',
          size: 3,
          validator: (item, value) => item.status.toLowerCase().includes(value.toLowerCase())
        },
        {
          id: 'position',
          name: 'Puesto',
          hint: 'Todos',
          icon: 'users',
          type: 'select',
          value: '',
          size: 3,
          validator: (item, value) => item.position == value
        },
        {
          id: 'date_from',
          name: 'Fecha Desde',
          hint: 'dd/mm/yyyy',
          icon: 'calendar-alt',
          type: 'date',
          size: 3,
          value: '',
          validator: (item, value) => new Date(item.start_date) >= new Date(reverseDate(value))
        },
        {
          id: 'date_to',
          name: 'Fecha Hasta',
          hint: 'dd/mm/yyyy',
          icon: 'calendar-alt',
          type: 'date',
          size: 3,
          value: '',
          validator: (item, value) => new Date(item.start_date) <= new Date(reverseDate(value))
        },
        {
          id: 'investment_from',
          name: 'Sueldo Desde',
          hint: '$0.00',
          icon: 'dollar-sign',
          type: 'number',
          size: 3,
          value: '',
          validator: (item, value) => item.salary >= value
        },
        {
          id: 'investment_to',
          name: 'Sueldo Hasta',
          hint: '$0.00',
          icon: 'dollar-sign',
          type: 'number',
          size: 3,
          value: '',
          validator: (item, value) => item.salary <= value
        }
      ]
    }
  },
  methods: {
    getItems (page = 1, filters = []) {
      this.tableData.draw++
      let params = this.tableData
      if (filters != null) {
        Object.assign(params, filters)
      } else {
        this.tableData = {
          draw: 1,
          length: 10,
          search: '',
          column: 0,
          dir: 'desc'
        }
        params = this.tableData
      }
      params.page = page
      colabsService.list(params)
        .then(response => {
          let data = response
          this.items = data.data
          let meta = data.meta
          this.meta.total = meta.total
          this.meta.total_amount = meta.total_amount
          this.configPagination(data.meta.pagination)
        })
        .catch(errors => {
          console.log(errors)
        })
    },
    configPagination (data) {
      this.pagination.lastPage = data.total_pages
      this.pagination.currentPage = data.current_page
      this.pagination.total = data.total
      this.pagination.links = (data.links) ? data.links : {}
      this.pagination.to = data.count * data.current_page
      this.pagination.from = this.pagination.to - data.count + 1
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/colaborators/Colaborators.vue